"use client";

import { useEffect } from "react";
import posthog from "posthog-js";
import * as Sentry from "@sentry/nextjs";
import {
  markSatelliteNavigationFailed,
  SatelliteErrorState,
} from "@to/ui";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    markSatelliteNavigationFailed();
    try {
      Sentry.captureException(error);
    } catch {
      // Error recovery cannot depend on telemetry delivery.
    }
    try {
      posthog.captureException(error);
    } catch {
      // Error recovery cannot depend on telemetry delivery.
    }
  }, [error]);

  return (
    <html lang="en">
      <body>
        <SatelliteErrorState reset={reset} />
      </body>
    </html>
  );
}
